import { cva, type VariantProps } from 'class-variance-authority';

export { default as Badge } from './Badge.vue';

export const badgeVariants = cva(
    'inline-flex items-center gap-2 rounded-md border py-2 px-2.5 text-xs text-foreground uppercase',
    {
        variants: {
            variant: {
                warning: 'border-warning/10 bg-warning/10',
                error: 'border-destructive/10 bg-destructive/10',
                success: 'border-accent/10 bg-accent/10',
            },
        },
        defaultVariants: {
            variant: 'warning',
        },
    },
);

export type BadgeVariants = VariantProps<typeof badgeVariants>;
